/**  Handles a toggle button */
class ToggleButtonComponent {
    /**  Initialises the toggle button component */
    init() {
        // Set the active state on labels for the toggle buttons
        $(".btn-group-toggle :checked").closest("label").addClass("active");
    }
}

$(function () {
    let toggleButton = new ToggleButtonComponent();
    toggleButton.init();
});